import { TextInput, Text } from '@mantine/core';
import { CommonInputProps } from './DataInputField';

export function DataInputPercentage({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  ariaLabelledBy,
}: CommonInputProps) {
  return (
    <TextInput
      value={String(inputValue || '')}
      onChange={e => setInputValue(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      type="number"
      rightSection={<Text size="xs">%</Text>}
      variant={variant}
      autoFocus={autoFocus}
      styles={{ input: { width: '80px' } }}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
